import React from 'react';
import styles from './BusinessPerformance.module.scss';
import LegAnalysis from './Structure/LegAnalysis';
import BusinessPerformanceOverview from './BusinessPerformanceOverview/BusinessPerformanceOverview';
import { useProfileParams } from '../../../utils/common';
import Pipeline from './Pipeline/Pipeline';
import IncomeQualification from './Income&Qualification/IncomeQualification';
import Portfolio from './Portfolio/Portfolio';

export const BusinessPerformance: React.FC<{}> = () => {
  const { aboNumber } = useProfileParams();

  return (
    <div
      className={styles.abo_growth_companion_wrapper}
      data-testid="business_information_plan_testID"
    >
      <div className={`content_inner ${styles.abo_growth_companion_inner_wrapper}`}>
        <div className={styles.section_wrapper}>
          <BusinessPerformanceOverview key={aboNumber} />
        </div>
        <div className={styles.section_wrapper}>
          <Pipeline category="pipeline" key={aboNumber} />
        </div>
        <div className={styles.section_wrapper}>
          <LegAnalysis category="structure" key={aboNumber} />
        </div>
        <div className={styles.section_wrapper}>
          <IncomeQualification key={aboNumber} />
        </div>
        <div className={styles.section_wrapper}>
          <Portfolio category="portfolio" key={aboNumber} />
        </div>
      </div>
    </div>
  );
};
